export function degToRad(deg) {
    return (deg * Math.PI) / 180;
}
export function radToDeg(rad) {
    return Number(((rad * 180) / Math.PI).toPrecision(5));
}
//# sourceMappingURL=angle-converter.js.map